<template>
    <section id="about" class="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div class="max-w-6xl mx-auto">
        <div class="text-center mb-10">
          <p class="text-emerald-600 text-sm font-semibold tracking-widest uppercase mb-3">About Me</p>
          <h2 class="text-3xl sm:text-4xl font-bold text-slate-900">
           Passionate about building impactful  <span class="text-emerald-600">software</span>
          </h2>
        </div>
        
        <div class="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <p class="text-lg text-slate-600 mb-6 leading-relaxed">
           I’m a passionate full-stack software developer with over 6 years of experience building scalable software solutions across different platforms. My journey began with curiosity about how technology shapes the world and evolved into a career focused on solving complex problems through clean, efficient, and maintainable code.
            </p>
            <p class="text-lg text-slate-600 mb-6 leading-relaxed">
              I specialize in creating seamless user experiences backed by robust architecture. Whether it's 
              a startup MVP or an enterprise solution, I approach each project with the same commitment to quality.
            </p>
            <p class="text-lg text-slate-600 leading-relaxed">
              When I'm not coding, you'll find me exploring new technologies, contributing to open-source projects,
              or sharing insights with the developer community.
            </p>
          </div>
          
          <div class="bg-slate-50 rounded-2xl p-8 border border-slate-100">
            <h3 class="text-xl font-bold text-slate-900 mb-8">Quick Facts</h3>
            <div class="space-y-6">
              <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <svg class="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p class="font-semibold text-slate-900">6+ Years Experience</p>
                  <p class="text-sm text-slate-500">Building production applications</p>
                </div>
              </div>
              
              <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-xl bg-teal-100 flex items-center justify-center flex-shrink-0">
                  <svg class="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                  </svg>
                </div>
                <div>
                  <p class="font-semibold text-slate-900">30+ Projects</p>
                  <p class="text-sm text-slate-500">Successfully delivered</p>
                </div>
              </div>
              
              <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-xl bg-cyan-100 flex items-center justify-center flex-shrink-0">
                  <svg class="w-6 h-6 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                  </svg>
                </div>
                <div>
                  <p class="font-semibold text-slate-900">Full Stack Expert</p>
                  <p class="text-sm text-slate-500">Frontend to deployment</p>
                </div>
              </div>
              
              <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <svg class="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div>
                  <p class="font-semibold text-slate-900">Always Learning</p>
                  <p class="text-sm text-slate-500">Staying current with tech</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
